var map = {
	"./2-img.png": "./src/assets/images/2-img.png",
	"./Pattern.png": "./src/assets/images/Pattern.png",
	"./aliser-auto/11 (2).jpg": "./src/assets/images/aliser-auto/11 (2).jpg",
	"./aliser-auto/11.jpg": "./src/assets/images/aliser-auto/11.jpg",
	"./aliser-auto/12.jpg": "./src/assets/images/aliser-auto/12.jpg",
	"./aliser-auto/14.jpg": "./src/assets/images/aliser-auto/14.jpg",
	"./aliser-auto/15.jpg": "./src/assets/images/aliser-auto/15.jpg",
	"./attachment-1.jpg": "./src/assets/images/attachment-1.jpg",
	"./attachment-2.jpg": "./src/assets/images/attachment-2.jpg",
	"./attachment-3.jpg": "./src/assets/images/attachment-3.jpg",
	"./auth-bg-1-old.jpg": "./src/assets/images/auth-bg-1-old.jpg",
	"./auth-bg-1.jpg": "./src/assets/images/auth-bg-1.jpg",
	"./auth-bg.jpg": "./src/assets/images/auth-bg.jpg",
	"./auth-layer.png": "./src/assets/images/auth-layer.png",
	"./avtar/1.jpg": "./src/assets/images/avtar/1.jpg",
	"./avtar/11.jpg": "./src/assets/images/avtar/11.jpg",
	"./avtar/16.jpg": "./src/assets/images/avtar/16.jpg",
	"./avtar/18.jpg": "./src/assets/images/avtar/18.jpg",
	"./avtar/3.jpg": "./src/assets/images/avtar/3.jpg",
	"./avtar/4.jpg": "./src/assets/images/avtar/4.jpg",
	"./avtar/5.jpg": "./src/assets/images/avtar/5.jpg",
	"./avtar/6.jpg": "./src/assets/images/avtar/6.jpg",
	"./avtar/7.jpg": "./src/assets/images/avtar/7.jpg",
	"./avtar/8.jpg": "./src/assets/images/avtar/8.jpg",
	"./banner/1.jpg": "./src/assets/images/banner/1.jpg",
	"./banner/2.jpg": "./src/assets/images/banner/2.jpg",
	"./banner/3.jpg": "./src/assets/images/banner/3.jpg",
	"./bg-profile.png": "./src/assets/images/bg-profile.png",
	"./blog/12.jpg": "./src/assets/images/blog/12.jpg",
	"./blog/12.png": "./src/assets/images/blog/12.png",
	"./blog/14.png": "./src/assets/images/blog/14.png",
	"./blog/4.jpg": "./src/assets/images/blog/4.jpg",
	"./blog/4.png": "./src/assets/images/blog/4.png",
	"./blog/9.jpg": "./src/assets/images/blog/9.jpg",
	"./blog/9.png": "./src/assets/images/blog/9.png",
	"./blog/blog-2.jpg": "./src/assets/images/blog/blog-2.jpg",
	"./blog/blog-3.jpg": "./src/assets/images/blog/blog-3.jpg",
	"./blog/blog-4.jpg": "./src/assets/images/blog/blog-4.jpg",
	"./blog/blog-5.png": "./src/assets/images/blog/blog-5.png",
	"./blog/blog-6.png": "./src/assets/images/blog/blog-6.png",
	"./blog/blog-single.jpg": "./src/assets/images/blog/blog-single.jpg",
	"./blog/blog.jpg": "./src/assets/images/blog/blog.jpg",
	"./blog/comment.jpg": "./src/assets/images/blog/comment.jpg",
	"./blog/img.png": "./src/assets/images/blog/img.png",
	"./calender-bg.png": "./src/assets/images/calender-bg.png",
	"./caller.jpg": "./src/assets/images/caller.jpg",
	"./clock-face.png": "./src/assets/images/clock-face.png",
	"./close-icon.png": "./src/assets/images/close-icon.png",
	"./cloud-bg-1.png": "./src/assets/images/cloud-bg-1.png",
	"./cloud-bg-2.png": "./src/assets/images/cloud-bg-2.png",
	"./codecanyon.png": "./src/assets/images/codecanyon.png",
	"./coming-soon-Logo.png": "./src/assets/images/coming-soon-Logo.png",
	"./coming-soon-bg.jpg": "./src/assets/images/coming-soon-bg.jpg",
	"./customizer/dark.png": "./src/assets/images/customizer/dark.png",
	"./customizer/light.png": "./src/assets/images/customizer/light.png",
	"./customizer/page-body-sidebar.png": "./src/assets/images/customizer/page-body-sidebar.png",
	"./customizer/page-bosy-dark.png": "./src/assets/images/customizer/page-bosy-dark.png",
	"./customizer/sidebar-dark.png": "./src/assets/images/customizer/sidebar-dark.png",
	"./customizer/sidebar.png": "./src/assets/images/customizer/sidebar.png",
	"./dashboard-icons/chat.png": "./src/assets/images/dashboard-icons/chat.png",
	"./dashboard-icons/document.png": "./src/assets/images/dashboard-icons/document.png",
	"./dashboard-icons/like.png": "./src/assets/images/dashboard-icons/like.png",
	"./dashboard-icons/operator.png": "./src/assets/images/dashboard-icons/operator.png",
	"./dashboard/boy-1.png": "./src/assets/images/dashboard/boy-1.png",
	"./dashboard/boy-2.png": "./src/assets/images/dashboard/boy-2.png",
	"./dashboard/boy.png": "./src/assets/images/dashboard/boy.png",
	"./dashboard/browser-sky.png": "./src/assets/images/dashboard/browser-sky.png",
	"./dashboard/browser-white.png": "./src/assets/images/dashboard/browser-white.png",
	"./dashboard/browser.png": "./src/assets/images/dashboard/browser.png",
	"./dashboard/chrome.png": "./src/assets/images/dashboard/chrome.png",
	"./dashboard/cloudy.png": "./src/assets/images/dashboard/cloudy.png",
	"./dashboard/cloudyt.png": "./src/assets/images/dashboard/cloudyt.png",
	"./dashboard/firefox.png": "./src/assets/images/dashboard/firefox.png",
	"./dashboard/moon.png": "./src/assets/images/dashboard/moon.png",
	"./dashboard/notification-sky.png": "./src/assets/images/dashboard/notification-sky.png",
	"./dashboard/notification-white.png": "./src/assets/images/dashboard/notification-white.png",
	"./dashboard/notification.png": "./src/assets/images/dashboard/notification.png",
	"./dashboard/opera.png": "./src/assets/images/dashboard/opera.png",
	"./dashboard/rain.png": "./src/assets/images/dashboard/rain.png",
	"./dashboard/safari.png": "./src/assets/images/dashboard/safari.png",
	"./dashboard/search-white.png": "./src/assets/images/dashboard/search-white.png",
	"./dashboard/search.png": "./src/assets/images/dashboard/search.png",
	"./dashboard/sun.png": "./src/assets/images/dashboard/sun.png",
	"./dashboard/translate-sky.png": "./src/assets/images/dashboard/translate-sky.png",
	"./dashboard/translate-white.png": "./src/assets/images/dashboard/translate-white.png",
	"./dashboard/translate.png": "./src/assets/images/dashboard/translate.png",
	"./dashboard/user-white.png": "./src/assets/images/dashboard/user-white.png",
	"./dashboard/user.png": "./src/assets/images/dashboard/user.png",
	"./dashboard/whether.png": "./src/assets/images/dashboard/whether.png",
	"./details_close.png": "./src/assets/images/details_close.png",
	"./details_open.png": "./src/assets/images/details_open.png",
	"./ecommerce/card.png": "./src/assets/images/ecommerce/card.png",
	"./ecommerce/payment-option/mastercard.png": "./src/assets/images/ecommerce/payment-option/mastercard.png",
	"./ecommerce/payment-option/paypal.png": "./src/assets/images/ecommerce/payment-option/paypal.png",
	"./ecommerce/payment-option/visa.png": "./src/assets/images/ecommerce/payment-option/visa.png",
	"./ecommerce/product-table/1.png": "./src/assets/images/ecommerce/product-table/1.png",
	"./ecommerce/product-table/2.png": "./src/assets/images/ecommerce/product-table/2.png",
	"./ecommerce/product-table/3.png": "./src/assets/images/ecommerce/product-table/3.png",
	"./ecommerce/product-table/4.png": "./src/assets/images/ecommerce/product-table/4.png",
	"./ecommerce/product-table/5.png": "./src/assets/images/ecommerce/product-table/5.png",
	"./ecommerce/product-table/6.png": "./src/assets/images/ecommerce/product-table/6.png",
	"./ecommerce/product/01.jpg": "./src/assets/images/ecommerce/product/01.jpg",
	"./ecommerce/product/02.jpg": "./src/assets/images/ecommerce/product/02.jpg",
	"./ecommerce/product/03.jpg": "./src/assets/images/ecommerce/product/03.jpg",
	"./ecommerce/product/04.jpg": "./src/assets/images/ecommerce/product/04.jpg",
	"./ecommerce/product/05.jpg": "./src/assets/images/ecommerce/product/05.jpg",
	"./ecommerce/product/06.jpg": "./src/assets/images/ecommerce/product/06.jpg",
	"./ecommerce/product/07.jpg": "./src/assets/images/ecommerce/product/07.jpg",
	"./ecommerce/product/08.jpg": "./src/assets/images/ecommerce/product/08.jpg",
	"./ecommerce/product/09.jpg": "./src/assets/images/ecommerce/product/09.jpg",
	"./ecommerce/product/10.jpg": "./src/assets/images/ecommerce/product/10.jpg",
	"./ecommerce/product/11.jpg": "./src/assets/images/ecommerce/product/11.jpg",
	"./ecommerce/product/12.jpg": "./src/assets/images/ecommerce/product/12.jpg",
	"./email/1.jpg": "./src/assets/images/email/1.jpg",
	"./email/2.jpg": "./src/assets/images/email/2.jpg",
	"./email/3.jpg": "./src/assets/images/email/3.jpg",
	"./email/4.jpg": "./src/assets/images/email/4.jpg",
	"./favicon.png": "./src/assets/images/favicon.png",
	"./hour.svg": "./src/assets/images/hour.svg",
	"./img-cropper.jpg": "./src/assets/images/img-cropper.jpg",
	"./js-grid - Copy.png": "./src/assets/images/js-grid - Copy.png",
	"./js-grid.png": "./src/assets/images/js-grid.png",
	"./key.png": "./src/assets/images/key.png",
	"./landing/Light-(Sidebar)-Dark-Layout.png": "./src/assets/images/landing/Light-(Sidebar)-Dark-Layout.png",
	"./landing/Solitary-Layout.png": "./src/assets/images/landing/Solitary-Layout.png",
	"./landing/UNIVERSAL.gif": "./src/assets/images/landing/UNIVERSAL.gif",
	"./landing/Vertical-Box-Layou.png": "./src/assets/images/landing/Vertical-Box-Layou.png",
	"./landing/Vertical-Dark-Nav-Layout.png": "./src/assets/images/landing/Vertical-Dark-Nav-Layout.png",
	"./landing/Vertical-Layout.png": "./src/assets/images/landing/Vertical-Layout.png",
	"./landing/admin-widgets.png": "./src/assets/images/landing/admin-widgets.png",
	"./landing/app/blog.png": "./src/assets/images/landing/app/blog.png",
	"./landing/app/chat.png": "./src/assets/images/landing/app/chat.png",
	"./landing/app/ecommerce.png": "./src/assets/images/landing/app/ecommerce.png",
	"./landing/app/email.png": "./src/assets/images/landing/app/email.png",
	"./landing/app/todo.png": "./src/assets/images/landing/app/todo.png",
	"./landing/app/user.png": "./src/assets/images/landing/app/user.png",
	"./landing/background.jpg": "./src/assets/images/landing/background.jpg",
	"./landing/button-builder-1.png": "./src/assets/images/landing/button-builder-1.png",
	"./landing/button-builder-2.png": "./src/assets/images/landing/button-builder-2.png",
	"./landing/button-builder-main.png": "./src/assets/images/landing/button-builder-main.png",
	"./landing/cooming/pre-build-admin-1.png": "./src/assets/images/landing/cooming/pre-build-admin-1.png",
	"./landing/cooming/pre-build-admin-2.png": "./src/assets/images/landing/cooming/pre-build-admin-2.png",
	"./landing/cooming/pre-build-admin-3.png": "./src/assets/images/landing/cooming/pre-build-admin-3.png",
	"./landing/cooming/pre-build-admin-4.png": "./src/assets/images/landing/cooming/pre-build-admin-4.png",
	"./landing/dashboard/1.jpg": "./src/assets/images/landing/dashboard/1.jpg",
	"./landing/dashboard/2.jpg": "./src/assets/images/landing/dashboard/2.jpg",
	"./landing/dashboard/3.jpg": "./src/assets/images/landing/dashboard/3.jpg",
	"./landing/dashboard/4.jpg": "./src/assets/images/landing/dashboard/4.jpg",
	"./landing/dashboard/5.jpg": "./src/assets/images/landing/dashboard/5.jpg",
	"./landing/exclusive-back-img.png": "./src/assets/images/landing/exclusive-back-img.png",
	"./landing/exclusive/1-1.png": "./src/assets/images/landing/exclusive/1-1.png",
	"./landing/exclusive/2-2.png": "./src/assets/images/landing/exclusive/2-2.png",
	"./landing/exclusive/3-3.png": "./src/assets/images/landing/exclusive/3-3.png",
	"./landing/exclusive/4-4.png": "./src/assets/images/landing/exclusive/4-4.png",
	"./landing/fontawesome-1.png": "./src/assets/images/landing/fontawesome-1.png",
	"./landing/fontawesome-2.png": "./src/assets/images/landing/fontawesome-2.png",
	"./landing/fontawesome-main.png": "./src/assets/images/landing/fontawesome-main.png",
	"./landing/form-builder-1.png": "./src/assets/images/landing/form-builder-1.png",
	"./landing/form-builder-2.png": "./src/assets/images/landing/form-builder-2.png",
	"./landing/form-builder-main.png": "./src/assets/images/landing/form-builder-main.png",
	"./landing/home/bg.jpg": "./src/assets/images/landing/home/bg.jpg",
	"./landing/home/main_bg.jpg": "./src/assets/images/landing/home/main_bg.jpg",
	"./landing/home/pattern.jpg": "./src/assets/images/landing/home/pattern.jpg",
	"./landing/home/right.png": "./src/assets/images/landing/home/right.png",
	"./landing/home/sliderq.jpg": "./src/assets/images/landing/home/sliderq.jpg",
	"./landing/icon/key-feature-1.png": "./src/assets/images/landing/icon/key-feature-1.png",
	"./landing/icon/key-feature-10.png": "./src/assets/images/landing/icon/key-feature-10.png",
	"./landing/icon/key-feature-11.png": "./src/assets/images/landing/icon/key-feature-11.png",
	"./landing/icon/key-feature-12.png": "./src/assets/images/landing/icon/key-feature-12.png",
	"./landing/icon/key-feature-13.png": "./src/assets/images/landing/icon/key-feature-13.png",
	"./landing/icon/key-feature-14.png": "./src/assets/images/landing/icon/key-feature-14.png",
	"./landing/icon/key-feature-15.png": "./src/assets/images/landing/icon/key-feature-15.png",
	"./landing/icon/key-feature-16.png": "./src/assets/images/landing/icon/key-feature-16.png",
	"./landing/icon/key-feature-17.png": "./src/assets/images/landing/icon/key-feature-17.png",
	"./landing/icon/key-feature-18.png": "./src/assets/images/landing/icon/key-feature-18.png",
	"./landing/icon/key-feature-2.png": "./src/assets/images/landing/icon/key-feature-2.png",
	"./landing/icon/key-feature-3.png": "./src/assets/images/landing/icon/key-feature-3.png",
	"./landing/icon/key-feature-4.png": "./src/assets/images/landing/icon/key-feature-4.png",
	"./landing/icon/key-feature-5.png": "./src/assets/images/landing/icon/key-feature-5.png",
	"./landing/icon/key-feature-6.png": "./src/assets/images/landing/icon/key-feature-6.png",
	"./landing/icon/key-feature-7.png": "./src/assets/images/landing/icon/key-feature-7.png",
	"./landing/icon/key-feature-8.png": "./src/assets/images/landing/icon/key-feature-8.png",
	"./landing/icon/key-feature-9.png": "./src/assets/images/landing/icon/key-feature-9.png",
	"./landing/laptop.png": "./src/assets/images/landing/laptop.png",
	"./landing/layout/1.jpg": "./src/assets/images/landing/layout/1.jpg",
	"./landing/layout/2.jpg": "./src/assets/images/landing/layout/2.jpg",
	"./landing/layout/3.jpg": "./src/assets/images/landing/layout/3.jpg",
	"./landing/layout/4.jpg": "./src/assets/images/landing/layout/4.jpg",
	"./landing/layout/5.jpg": "./src/assets/images/landing/layout/5.jpg",
	"./landing/layouts/1.jpg": "./src/assets/images/landing/layouts/1.jpg",
	"./landing/layouts/10.jpg": "./src/assets/images/landing/layouts/10.jpg",
	"./landing/layouts/11.jpg": "./src/assets/images/landing/layouts/11.jpg",
	"./landing/layouts/12.jpg": "./src/assets/images/landing/layouts/12.jpg",
	"./landing/layouts/13.jpg": "./src/assets/images/landing/layouts/13.jpg",
	"./landing/layouts/14.jpg": "./src/assets/images/landing/layouts/14.jpg",
	"./landing/layouts/15.jpg": "./src/assets/images/landing/layouts/15.jpg",
	"./landing/layouts/16.jpg": "./src/assets/images/landing/layouts/16.jpg",
	"./landing/layouts/17.jpg": "./src/assets/images/landing/layouts/17.jpg",
	"./landing/layouts/18.jpg": "./src/assets/images/landing/layouts/18.jpg",
	"./landing/layouts/19.jpg": "./src/assets/images/landing/layouts/19.jpg",
	"./landing/layouts/2.jpg": "./src/assets/images/landing/layouts/2.jpg",
	"./landing/layouts/20.jpg": "./src/assets/images/landing/layouts/20.jpg",
	"./landing/layouts/21.jpg": "./src/assets/images/landing/layouts/21.jpg",
	"./landing/layouts/22.jpg": "./src/assets/images/landing/layouts/22.jpg",
	"./landing/layouts/23.jpg": "./src/assets/images/landing/layouts/23.jpg",
	"./landing/layouts/24.jpg": "./src/assets/images/landing/layouts/24.jpg",
	"./landing/layouts/3.jpg": "./src/assets/images/landing/layouts/3.jpg",
	"./landing/layouts/4.jpg": "./src/assets/images/landing/layouts/4.jpg",
	"./landing/layouts/5.jpg": "./src/assets/images/landing/layouts/5.jpg",
	"./landing/layouts/6.jpg": "./src/assets/images/landing/layouts/6.jpg",
	"./landing/layouts/7.jpg": "./src/assets/images/landing/layouts/7.jpg",
	"./landing/layouts/8.jpg": "./src/assets/images/landing/layouts/8.jpg",
	"./landing/layouts/9.jpg": "./src/assets/images/landing/layouts/9.jpg",
	"./landing/layouts_prebuild/1.jpg": "./src/assets/images/landing/layouts_prebuild/1.jpg",
	"./landing/layouts_prebuild/10.jpg": "./src/assets/images/landing/layouts_prebuild/10.jpg",
	"./landing/layouts_prebuild/11.jpg": "./src/assets/images/landing/layouts_prebuild/11.jpg",
	"./landing/layouts_prebuild/12.jpg": "./src/assets/images/landing/layouts_prebuild/12.jpg",
	"./landing/layouts_prebuild/13.jpg": "./src/assets/images/landing/layouts_prebuild/13.jpg",
	"./landing/layouts_prebuild/14.jpg": "./src/assets/images/landing/layouts_prebuild/14.jpg",
	"./landing/layouts_prebuild/15.jpg": "./src/assets/images/landing/layouts_prebuild/15.jpg",
	"./landing/layouts_prebuild/16.jpg": "./src/assets/images/landing/layouts_prebuild/16.jpg",
	"./landing/layouts_prebuild/17.jpg": "./src/assets/images/landing/layouts_prebuild/17.jpg",
	"./landing/layouts_prebuild/18.jpg": "./src/assets/images/landing/layouts_prebuild/18.jpg",
	"./landing/layouts_prebuild/19.jpg": "./src/assets/images/landing/layouts_prebuild/19.jpg",
	"./landing/layouts_prebuild/2.jpg": "./src/assets/images/landing/layouts_prebuild/2.jpg",
	"./landing/layouts_prebuild/20.jpg": "./src/assets/images/landing/layouts_prebuild/20.jpg",
	"./landing/layouts_prebuild/21.jpg": "./src/assets/images/landing/layouts_prebuild/21.jpg",
	"./landing/layouts_prebuild/22.jpg": "./src/assets/images/landing/layouts_prebuild/22.jpg",
	"./landing/layouts_prebuild/23.jpg": "./src/assets/images/landing/layouts_prebuild/23.jpg",
	"./landing/layouts_prebuild/24.jpg": "./src/assets/images/landing/layouts_prebuild/24.jpg",
	"./landing/layouts_prebuild/3.jpg": "./src/assets/images/landing/layouts_prebuild/3.jpg",
	"./landing/layouts_prebuild/4.jpg": "./src/assets/images/landing/layouts_prebuild/4.jpg",
	"./landing/layouts_prebuild/5.jpg": "./src/assets/images/landing/layouts_prebuild/5.jpg",
	"./landing/layouts_prebuild/6.jpg": "./src/assets/images/landing/layouts_prebuild/6.jpg",
	"./landing/layouts_prebuild/7.jpg": "./src/assets/images/landing/layouts_prebuild/7.jpg",
	"./landing/layouts_prebuild/8.jpg": "./src/assets/images/landing/layouts_prebuild/8.jpg",
	"./landing/layouts_prebuild/9.jpg": "./src/assets/images/landing/layouts_prebuild/9.jpg",
	"./landing/page-builder-1.png": "./src/assets/images/landing/page-builder-1.png",
	"./landing/page-builder-2.png": "./src/assets/images/landing/page-builder-2.png",
	"./landing/page-builder-3.png": "./src/assets/images/landing/page-builder-3.png",
	"./landing/page-builder-main.png": "./src/assets/images/landing/page-builder-main.png",
	"./landing/particles-back-img.png": "./src/assets/images/landing/particles-back-img.png",
	"./landing/polygon.png": "./src/assets/images/landing/polygon.png",
	"./landing/view-demo-1.png": "./src/assets/images/landing/view-demo-1.png",
	"./landing/view-demo-2.png": "./src/assets/images/landing/view-demo-2.png",
	"./landing/view-demo-3.png": "./src/assets/images/landing/view-demo-3.png",
	"./landing/view-demo-4.png": "./src/assets/images/landing/view-demo-4.png",
	"./landing/widgets-bck.png": "./src/assets/images/landing/widgets-bck.png",
	"./lightgallry/01.jpg": "./src/assets/images/lightgallry/01.jpg",
	"./lightgallry/010.jpg": "./src/assets/images/lightgallry/010.jpg",
	"./lightgallry/011.jpg": "./src/assets/images/lightgallry/011.jpg",
	"./lightgallry/012.jpg": "./src/assets/images/lightgallry/012.jpg",
	"./lightgallry/013.jpg": "./src/assets/images/lightgallry/013.jpg",
	"./lightgallry/014.jpg": "./src/assets/images/lightgallry/014.jpg",
	"./lightgallry/015.jpg": "./src/assets/images/lightgallry/015.jpg",
	"./lightgallry/016.jpg": "./src/assets/images/lightgallry/016.jpg",
	"./lightgallry/02.jpg": "./src/assets/images/lightgallry/02.jpg",
	"./lightgallry/03.jpg": "./src/assets/images/lightgallry/03.jpg",
	"./lightgallry/04.jpg": "./src/assets/images/lightgallry/04.jpg",
	"./lightgallry/05.jpg": "./src/assets/images/lightgallry/05.jpg",
	"./lightgallry/06.jpg": "./src/assets/images/lightgallry/06.jpg",
	"./lightgallry/07.jpg": "./src/assets/images/lightgallry/07.jpg",
	"./lightgallry/08.jpg": "./src/assets/images/lightgallry/08.jpg",
	"./lightgallry/09.jpg": "./src/assets/images/lightgallry/09.jpg",
	"./lightgallry/big/01.jpg": "./src/assets/images/lightgallry/big/01.jpg",
	"./lightgallry/big/010.jpg": "./src/assets/images/lightgallry/big/010.jpg",
	"./lightgallry/big/011.jpg": "./src/assets/images/lightgallry/big/011.jpg",
	"./lightgallry/big/012.jpg": "./src/assets/images/lightgallry/big/012.jpg",
	"./lightgallry/big/013.jpg": "./src/assets/images/lightgallry/big/013.jpg",
	"./lightgallry/big/014.jpg": "./src/assets/images/lightgallry/big/014.jpg",
	"./lightgallry/big/015.jpg": "./src/assets/images/lightgallry/big/015.jpg",
	"./lightgallry/big/016.jpg": "./src/assets/images/lightgallry/big/016.jpg",
	"./lightgallry/big/02.jpg": "./src/assets/images/lightgallry/big/02.jpg",
	"./lightgallry/big/03.jpg": "./src/assets/images/lightgallry/big/03.jpg",
	"./lightgallry/big/04.jpg": "./src/assets/images/lightgallry/big/04.jpg",
	"./lightgallry/big/05.jpg": "./src/assets/images/lightgallry/big/05.jpg",
	"./lightgallry/big/06.jpg": "./src/assets/images/lightgallry/big/06.jpg",
	"./lightgallry/big/07.jpg": "./src/assets/images/lightgallry/big/07.jpg",
	"./lightgallry/big/08.jpg": "./src/assets/images/lightgallry/big/08.jpg",
	"./lightgallry/big/09.jpg": "./src/assets/images/lightgallry/big/09.jpg",
	"./lightgallry/default-skin.png": "./src/assets/images/lightgallry/default-skin.png",
	"./lightgallry/default-skin.svg": "./src/assets/images/lightgallry/default-skin.svg",
	"./loading.gif": "./src/assets/images/loading.gif",
	"./location (2).png": "./src/assets/images/location (2).png",
	"./location.png": "./src/assets/images/location.png",
	"./login-image.jpg": "./src/assets/images/login-image.jpg",
	"./logo-auth.gif": "./src/assets/images/logo-auth.gif",
	"./logo-dark.png": "./src/assets/images/logo-dark.png",
	"./logo-light-dark-layout.png": "./src/assets/images/logo-light-dark-layout.png",
	"./logo-light.png": "./src/assets/images/logo-light.png",
	"./logo-login.png": "./src/assets/images/logo-login.png",
	"./logo.png": "./src/assets/images/logo.png",
	"./maintence-bg.jpg": "./src/assets/images/maintence-bg.jpg",
	"./masonry/1.jpg": "./src/assets/images/masonry/1.jpg",
	"./masonry/10.jpg": "./src/assets/images/masonry/10.jpg",
	"./masonry/11.jpg": "./src/assets/images/masonry/11.jpg",
	"./masonry/12.jpg": "./src/assets/images/masonry/12.jpg",
	"./masonry/13.jpg": "./src/assets/images/masonry/13.jpg",
	"./masonry/14.jpg": "./src/assets/images/masonry/14.jpg",
	"./masonry/15.jpg": "./src/assets/images/masonry/15.jpg",
	"./masonry/16.jpg": "./src/assets/images/masonry/16.jpg",
	"./masonry/17.jpg": "./src/assets/images/masonry/17.jpg",
	"./masonry/18.jpg": "./src/assets/images/masonry/18.jpg",
	"./masonry/2.jpg": "./src/assets/images/masonry/2.jpg",
	"./masonry/3.jpg": "./src/assets/images/masonry/3.jpg",
	"./masonry/4.jpg": "./src/assets/images/masonry/4.jpg",
	"./masonry/5.jpg": "./src/assets/images/masonry/5.jpg",
	"./masonry/6.jpg": "./src/assets/images/masonry/6.jpg",
	"./masonry/7.jpg": "./src/assets/images/masonry/7.jpg",
	"./masonry/8.jpg": "./src/assets/images/masonry/8.jpg",
	"./masonry/9.jpg": "./src/assets/images/masonry/9.jpg",
	"./masonry/big/1.jpg": "./src/assets/images/masonry/big/1.jpg",
	"./masonry/big/10.jpg": "./src/assets/images/masonry/big/10.jpg",
	"./masonry/big/11.jpg": "./src/assets/images/masonry/big/11.jpg",
	"./masonry/big/12.jpg": "./src/assets/images/masonry/big/12.jpg",
	"./masonry/big/13.jpg": "./src/assets/images/masonry/big/13.jpg",
	"./masonry/big/14.jpg": "./src/assets/images/masonry/big/14.jpg",
	"./masonry/big/15.jpg": "./src/assets/images/masonry/big/15.jpg",
	"./masonry/big/16.jpg": "./src/assets/images/masonry/big/16.jpg",
	"./masonry/big/17.jpg": "./src/assets/images/masonry/big/17.jpg",
	"./masonry/big/18.jpg": "./src/assets/images/masonry/big/18.jpg",
	"./masonry/big/2.jpg": "./src/assets/images/masonry/big/2.jpg",
	"./masonry/big/3.jpg": "./src/assets/images/masonry/big/3.jpg",
	"./masonry/big/4.jpg": "./src/assets/images/masonry/big/4.jpg",
	"./masonry/big/5.jpg": "./src/assets/images/masonry/big/5.jpg",
	"./masonry/big/6.jpg": "./src/assets/images/masonry/big/6.jpg",
	"./masonry/big/7.jpg": "./src/assets/images/masonry/big/7.jpg",
	"./masonry/big/8.jpg": "./src/assets/images/masonry/big/8.jpg",
	"./masonry/big/9.jpg": "./src/assets/images/masonry/big/9.jpg",
	"./mega-menu-bg.png": "./src/assets/images/mega-menu-bg.png",
	"./min.svg": "./src/assets/images/min.svg",
	"./mobile-clock-wallpaper.jpg": "./src/assets/images/mobile-clock-wallpaper.jpg",
	"./nyan-cat.gif": "./src/assets/images/nyan-cat.gif",
	"./open-lock.png": "./src/assets/images/open-lock.png",
	"./paypal.png": "./src/assets/images/paypal.png",
	"./product/1.png": "./src/assets/images/product/1.png",
	"./product/2.png": "./src/assets/images/product/2.png",
	"./product/3.png": "./src/assets/images/product/3.png",
	"./product/4.png": "./src/assets/images/product/4.png",
	"./profile-style-img.png": "./src/assets/images/profile-style-img.png",
	"./profile-style-img2.png": "./src/assets/images/profile-style-img2.png",
	"./profile-style-img3.png": "./src/assets/images/profile-style-img3.png",
	"./receiver-img.jpg": "./src/assets/images/receiver-img.jpg",
	"./sad.png": "./src/assets/images/sad.png",
	"./sec.svg": "./src/assets/images/sec.svg",
	"./secondhandm.png": "./src/assets/images/secondhandm.png",
	"./sidebar-bg.jpg": "./src/assets/images/sidebar-bg.jpg",
	"./slider-auto-width/11.jpg": "./src/assets/images/slider-auto-width/11.jpg",
	"./slider-auto-width/12.jpg": "./src/assets/images/slider-auto-width/12.jpg",
	"./slider-auto-width/13.jpg": "./src/assets/images/slider-auto-width/13.jpg",
	"./slider-auto-width/14.jpg": "./src/assets/images/slider-auto-width/14.jpg",
	"./slider-auto-width/15.jpg": "./src/assets/images/slider-auto-width/15.jpg",
	"./slider/1.jpg": "./src/assets/images/slider/1.jpg",
	"./slider/10.jpg": "./src/assets/images/slider/10.jpg",
	"./slider/11.jpg": "./src/assets/images/slider/11.jpg",
	"./slider/12.jpg": "./src/assets/images/slider/12.jpg",
	"./slider/13.jpg": "./src/assets/images/slider/13.jpg",
	"./slider/14.jpg": "./src/assets/images/slider/14.jpg",
	"./slider/2.jpg": "./src/assets/images/slider/2.jpg",
	"./slider/3.jpg": "./src/assets/images/slider/3.jpg",
	"./slider/4.jpg": "./src/assets/images/slider/4.jpg",
	"./slider/5.jpg": "./src/assets/images/slider/5.jpg",
	"./slider/6.jpg": "./src/assets/images/slider/6.jpg",
	"./slider/7.jpg": "./src/assets/images/slider/7.jpg",
	"./slider/8.jpg": "./src/assets/images/slider/8.jpg",
	"./slider/9.jpg": "./src/assets/images/slider/9.jpg",
	"./smiley.png": "./src/assets/images/smiley.png",
	"./sort_asc.png": "./src/assets/images/sort_asc.png",
	"./sort_asc_disabled.png": "./src/assets/images/sort_asc_disabled.png",
	"./sort_both.png": "./src/assets/images/sort_both.png",
	"./sort_desc.png": "./src/assets/images/sort_desc.png",
	"./sort_desc_disabled.png": "./src/assets/images/sort_desc_disabled.png",
	"./themeforest-icon.png": "./src/assets/images/themeforest-icon.png",
	"./tilt.jpg": "./src/assets/images/tilt.jpg",
	"./ui-bg_flat_0_aaaaaa_40x100.png": "./src/assets/images/ui-bg_flat_0_aaaaaa_40x100.png",
	"./ui-icons_444444_256x240.png": "./src/assets/images/ui-icons_444444_256x240.png",
	"./ui-icons_555555_256x240.png": "./src/assets/images/ui-icons_555555_256x240.png",
	"./ui-icons_777620_256x240.png": "./src/assets/images/ui-icons_777620_256x240.png",
	"./ui-icons_777777_256x240.png": "./src/assets/images/ui-icons_777777_256x240.png",
	"./ui-icons_cc0000_256x240.png": "./src/assets/images/ui-icons_cc0000_256x240.png",
	"./ui-icons_ffffff_256x240.png": "./src/assets/images/ui-icons_ffffff_256x240.png",
	"./user-card/1.jpg": "./src/assets/images/user-card/1.jpg",
	"./user-card/2.jpg": "./src/assets/images/user-card/2.jpg",
	"./user-card/3.jpg": "./src/assets/images/user-card/3.jpg",
	"./user-card/4.jpg": "./src/assets/images/user-card/4.jpg",
	"./user/1.jpg": "./src/assets/images/user/1.jpg",
	"./user/10.jpg": "./src/assets/images/user/10.jpg",
	"./user/11.png": "./src/assets/images/user/11.png",
	"./user/12.png": "./src/assets/images/user/12.png",
	"./user/13.png": "./src/assets/images/user/13.png",
	"./user/14.png": "./src/assets/images/user/14.png",
	"./user/2.png": "./src/assets/images/user/2.png",
	"./user/3.png": "./src/assets/images/user/3.png",
	"./user/4.jpg": "./src/assets/images/user/4.jpg",
	"./user/5.jpg": "./src/assets/images/user/5.jpg",
	"./user/6.jpg": "./src/assets/images/user/6.jpg",
	"./user/7.jpg": "./src/assets/images/user/7.jpg",
	"./user/8.jpg": "./src/assets/images/user/8.jpg",
	"./user/9.jpg": "./src/assets/images/user/9.jpg",
	"./user/user.png": "./src/assets/images/user/user.png",
	"./whether-widgetbg.jpg": "./src/assets/images/whether-widgetbg.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";